var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { BinIconGlyph, CrossIconGlyph, EditIconGlyph, PlusIconGlyph, QuestionIconGlyph, TickIconGlyph } from '@shapeable/icons';
import { SiteLogo } from '../entities/site-logo';
import { useThemeMode } from '../hooks/use-theme-mode';
var cls = classNames('app-dialog-title');
// -------- Types -------->
var AppDialogTitleActionLabels = {
  edit: 'Edit',
  assign: 'Assign',
  add: 'Add',
  confirm: 'Confirm',
  delete: 'Delete'
};
var AppDialogTitleActionIcons = {
  edit: EditIconGlyph,
  assign: PlusIconGlyph,
  add: PlusIconGlyph,
  confirm: QuestionIconGlyph,
  delete: BinIconGlyph
};
export var AppDialogTitleDefaultProps = {
  closeAction: 'close'
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-size: ", ";\n    position: relative;\n    display: flex;\n    height: 50px;\n    border-radius: ", " ", " 0 0;\n    padding: 0 ", ";\n    align-items: center;\n    justify-content: center;\n    color: ", ";\n    background: ", ";\n    cursor: -webkit-grab;\n    user-select: none;\n    &:active {\n      cursor: -webkit-grabbing;\n    }\n  "], ["\n    font-size: ", ";\n    position: relative;\n    display: flex;\n    height: 50px;\n    border-radius: ", " ", " 0 0;\n    padding: 0 ", ";\n    align-items: center;\n    justify-content: center;\n    color: ", ";\n    background: ", ";\n    cursor: -webkit-grab;\n    user-select: none;\n    &:active {\n      cursor: -webkit-grabbing;\n    }\n  "])), theme.FONT_SIZE(15), theme.UNIT(2), theme.UNIT(2), theme.UNIT(50), theme.COLOR('text-chrome'), theme.COLOR('app-chrome'))
});
var LogoStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: absolute;\n    top: ", ";\n    left: ", ";\n    height: 28px;\n    \n    img {\n      user-drag: none;\n      pointer-events: none;\n      max-height: 100%;\n    }\n  "], ["\n    position: absolute;\n    top: ", ";\n    left: ", ";\n    height: 28px;\n    \n    img {\n      user-drag: none;\n      pointer-events: none;\n      max-height: 100%;\n    }\n  "])), theme.UNIT(3), theme.UNIT(4))
});
var BodyStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap : ", ";\n  "], ["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap : ", ";\n  "])), theme.UNIT(2))
});
var TitleStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    font-weight: 400;\n    font-size: 1em;\n    display: flex;\n    flex-direction: row;\n    gap: ", ";\n    padding-bottom: 1px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  "], ["\n    font-weight: 400;\n    font-size: 1em;\n    display: flex;\n    flex-direction: row;\n    gap: ", ";\n    padding-bottom: 1px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  "])), theme.UNIT(1))
});
var ActionStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    font-weight: 600; \n  "], ["\n    font-weight: 600; \n  "])))
});
var ButtonIconStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var CloseButtonStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    ", ";\n    ", ";\n    position: absolute;\n    height: 50px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 50px;\n    top: 1px;\n    right: 1px;\n    cursor: pointer;\n\n  "], ["\n    ", ";\n    ", ";\n    position: absolute;\n    height: 50px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 50px;\n    top: 1px;\n    right: 1px;\n    cursor: pointer;\n\n  "])), theme.APPLY_COLORS, theme.REMOVE_BUTTON_STYLE())
});
// -------- Components -------->
var My = {
  NAME: 'AppDialogTitle',
  Container: styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Logo: styled(SiteLogo)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), LogoStyles),
  Body: styled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Title: styled.h2(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  Action: styled.b(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), ActionStyles),
  CloseButton: styled.button(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), CloseButtonStyles),
  CloseButtonIcon: styled(CrossIconGlyph)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), ButtonIconStyles),
  DoneButtonIcon: styled(TickIconGlyph)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), ButtonIconStyles)
};
export var AppDialogTitle = function (props) {
  var componentProps = useComponentProps(My.NAME, AppDialogTitleDefaultProps, props);
  var className = componentProps.className,
    children = componentProps.children,
    action = componentProps.action,
    closeAction = componentProps.closeAction,
    onCloseClick = componentProps.onCloseClick;
  var closeActionButtons = {
    close: My.CloseButtonIcon,
    done: My.DoneButtonIcon
  };
  var CloseButtonIcon = closeActionButtons[closeAction] || My.CloseButton;
  var actionLabel = AppDialogTitleActionLabels[action];
  var Icon = componentProps.icon || action && AppDialogTitleActionIcons[action];
  var themeMode = useThemeMode();
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Logo, {
    isLink: false,
    variant: themeMode === 'dark' ? 'inverted' : 'default'
  }), React.createElement(My.Body, null, Icon && React.createElement(Icon, {
    style: {
      marginTop: '-2px'
    },
    colors: {
      fill: 'text-chrome'
    },
    size: 14
  }), React.createElement(My.Title, null, actionLabel && React.createElement(My.Action, null, actionLabel), children)), React.createElement(My.CloseButton, {
    colors: {
      fill: 'strong-chrome',
      hover: {
        fill: 'strong'
      }
    },
    onClick: onCloseClick
  }, React.createElement(CloseButtonIcon, {
    colors: {
      fill: 'strong-chrome',
      hover: {
        fill: 'strong'
      }
    },
    size: 14
  })));
};
AppDialogTitle.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15;